import { render, staticRenderFns } from "./starred-segments.vue?vue&type=template&id=20d1d5f6&"
import script from "./starred-segments.vue?vue&type=script&lang=js&"
export * from "./starred-segments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports